import Vue from "vue";
import { store } from "../src/store/index.js";
import Router from "vue-router";
import BeezcodeScreen from "./views/BeezcodeScreen";
import EmailVerification from "./views/EmailVerification";
import CreateProfile from "./views/CreateProfile";
import EligbilityScreen from "./views/EligbilityScreen";
import ApplicationSubmittedScreen from "./views/ApplicationSubmittedScreen";
import LoginScreen from "./views/LoginScreen";
import SignupScreen from "./views/SignupScreen";
import IntroScreen from "./views/IntroScreen";
import SubmissionScreen from "./views/SubmissionScreen";
import InstructionsScreen from "./views/InstructionsScreen";
import SubmissionEnd from "./views/EndSubmission";
import amplitude from "amplitude-js";

// import ApplicantsList from './selector_flow/ApplicantsList.vue';
import Dashboard from "./selector_flow/Dashboard.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: SubmissionScreen,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: "/welcome",
      name: "welcome",
      component: BeezcodeScreen,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/login",
      name: "login",
      component: LoginScreen,
      meta: { requiresAuth: false }
    },
    {
      path: "/signup",
      name: "signup",
      component: SignupScreen,
      meta: { requiresAuth: false }
    },
    {
      path: "/intro",
      name: "intro",
      component: IntroScreen,
      meta: { requiresAuth: false }
    },

    {
      path: "/verify",
      name: "verify",
      component: EmailVerification,
      props: true,
      meta: { requiresAuth: true }
    },

    {
      path: "/profile",
      name: "profile",
      component: CreateProfile,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: "/eligbility",
      name: "eligbility",
      component: EligbilityScreen,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: "/application-submitted",
      name: "applicationSubmitted",
      component: ApplicationSubmittedScreen,
      meta: { requiresAuth: true }
    },
    {
      path: "/submission-end",
      name: "submissionEnd",
      component: SubmissionEnd,
      meta: { requiresAuth: false }
    },
    {
      path: "/instructions",
      name: "instructions",
      component: InstructionsScreen,
      meta: { requiresAuth: true }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: { requiresAuth: true }
    }
  ]
});

/**
 * Gloabl router navigation guard that check if user
 * is logged in or not
 */
router.beforeEach(async (to, from, next) => {
  if (process.env.VUE_APP_DISABLE_ROUTE === "true") {
    next();
    return;
  }

  let isLoggedIn = false;
  let isVerified = false;
  let profileExists = false;
  let isEligible = false;
  let appSubmitted = false;
  let isSelector = false;

  // dispatch action
  // to check if user is logged in
  try {
    // get current user (if logged in)
    const { user } = await store.dispatch(
      "auth/authenticate",
      {},
      { root: true }
    );

    if (user.type == "APPLICANT") {
      const submissionEnds = await store.dispatch(
        "auth/isSubmissionEnds",
        {},
        { root: true }
      );

      if (submissionEnds) {
        if (to.name !== "submissionEnd") {
          next({
            name: "submissionEnd"
          });
        } else {
          next();
        }
        return;
      }

      isLoggedIn = true;
      isVerified = user.isVerified;

      // get profile
      const profile = await store.dispatch(
        "profile/currentProfile",
        {},
        { root: true }
      );

      if (profile._id && profile._id.length) {
        profileExists = true;
      }

      if (profile.isEligible) {
        isEligible = true;
      }

      appSubmitted = profile.isComplete;
    } else if (user.type == "SELECTOR") {
      isLoggedIn = true;
      isSelector = true;
    }
  } catch (error) {
    if (error.code === 404) {
      store.dispatch("auth/logoutUser", {}, { root: true });
    }
  }

  // route which requires auth
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // if the user is not logged in
    // and he try to access endpoint which requires auth
    // then we need to redirect him to the welcome screen
    if (!isLoggedIn) {
      if (to.name !== "signup") {
        next({
          name: "welcome"
        });
      } else {
        next();
      }
    } else {
      if (!isSelector) {
        if (!isVerified) {
          if (to.name !== "verify") {
            next({
              name: "verify"
            });
          } else {
            next();
          }
        } else if (!profileExists) {
          if (to.name === "instructions") {
            next();
          } else if (to.name !== "profile") {
            next({
              name: "profile"
            });
          } else {
            next();
          }
        } else if (!isEligible) {
          if (to.name !== "eligbility" && from.name !== "eligbility") {
            next({
              name: "eligbility"
            });
          } else {
            next();
          }
        } else if (appSubmitted) {
          if (
            to.name !== "applicationSubmitted" &&
            from.name !== "applicationSubmitted"
          ) {
            next({
              name: "applicationSubmitted"
            });
          } else {
            next();
          }
        } else {
          if (to.name !== "home" && from.name !== "home") {
            next({
              name: "home"
            });
          } else {
            next();
          }
        }
      } else {
        if (to.name === "home" && isSelector) {
          next({
            name: "dashboard"
          });
        } else {
          next();
        }
      }
    }
  } else {
    // route which does not require auth

    // if the user is logged in we cannot allow him to
    // see screens which are not required auth

    if (isLoggedIn) {
      if (isSelector) {
        if (to.name === "home") {
          next({
            name: "dashboard"
          });
        }
      } else if (!isSelector) {
        next({
          name: "home"
        });
      }
    } else {
      // not logged in
      next();
    }
  }
});

export default router;
